<template>
  <div class="pt-20">
    <SubHeader title="تواصل معنا" background="/images/contact-bg.webp" />
    <ContactUs />
  </div>
</template>
